import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp, Compass, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const STEPS = [
  {
    title: "1. Förbered",
    text: "Bestäm vem som är Bas-P och Bas-U, kolla om förhandsanmälan behövs och beskriv projektet.",
  },
  {
    title: "2. Planera",
    text: "Utred arbetsområdet, samla riskerna och skriv arbetsmiljöplanen som gäller på bygget.",
  },
  {
    title: "3. Bygg",
    text: "Introducera alla på plats, gör arbetsberedningar, skyddsronder och rapportera tillbud.",
  },
  {
    title: "4. Lämna över",
    text: "Samla kvarvarande risker och lämna hela dokumentationen till byggherren och förvaltningen.",
  },
];

const STORAGE_KEY = "basprocess.introOpen";

/** Kort introduktion högst upp i Bas-processen, för den som inte jobbar med detta dagligen. */
export const ProcessIntroCard: React.FC = () => {
  const [open, setOpen] = useState(() =>
    typeof window === "undefined" ? true : window.localStorage.getItem(STORAGE_KEY) !== "0"
  );

  const toggle = () => {
    setOpen((v) => {
      window.localStorage.setItem(STORAGE_KEY, v ? "0" : "1");
      return !v;
    });
  };

  return (
    <Card className="border-primary/25 bg-primary/5">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-2">
            <Compass className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
            <div>
              <p className="text-sm font-semibold">Så fungerar hela processen på en minut</p>
              <p className="text-sm text-muted-foreground">
                Fyra skeden – varje dokument har en knapp med &quot;Så här gör du&quot;.
              </p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={toggle} aria-expanded={open}>
            {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          </Button>
        </div>

        {open && (
          <>
            <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
              {STEPS.map((s) => (
                <div key={s.title} className="rounded-lg border border-border/60 bg-background p-3">
                  <p className="text-sm font-semibold">{s.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{s.text}</p>
                </div>
              ))}
            </div>
            <Button asChild variant="link" size="sm" className="mt-1 px-0">
              <Link to="/guide">
                Öppna steg-för-steg-guiden <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default ProcessIntroCard;
